import React, { PureComponent } from 'react';
import getSetCookie from '../../../../cookie';
import { Link } from 'react-router-dom';
import { onImageLoadError, roundUptoDigits, removeDomainName } from '../../../../utils/helper';
import './WidgetProductNew.scss';
import ColorOptions from './ColorOptions';
import config from 'config';
import { connect } from 'react-redux';
import { addToWishListGA4 } from '../../../../utils/gaFour';

class WidgetProductNew extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dittoImage: null,
      exchangeMarketPrice: '',
      exchangePrice: '',
    };
    this._isMounted = false;
    this.fnCreateMyDitto = this.fnCreateMyDitto.bind(this);
  }
  componentDidMount() {
    this._isMounted = true;
    const { productData, showDitto } = this.props;
    if (showDitto && productData.is_ditto) {
      this.getDittoImage(productData.id);
    }
  }
  componentDidUpdate(prevProps) {
    const { showDitto, productData } = this.props;
    if (productData.is_ditto && prevProps.showDitto !== showDitto && showDitto) {
      this.getDittoImage(productData.id);
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  getDittoImage(sku) {
    const dittoAccessID = getSetCookie.getCookie('dittoAccessID');
    const dittoSignature = getSetCookie.getCookie('dittoSignature');
    if (getSetCookie.getCookie('isDittoID') && dittoSignature) {
      fetch(
        `${config.ditto.vtoUrl}${getSetCookie.getCookie(
          'isDittoID'
        )}/frontal-frame/?product_id=${sku}&size=300x240`,
        {
          headers: {
            'X-Ditto-Access-Key-Id': dittoAccessID,
            'X-Ditto-Signature': dittoSignature,
          },
        }
      )
        .then(res => res.blob())
        .then(url => {
          const image = URL.createObjectURL(url);
          if (this._isMounted) {
            this.setState({
              dittoImage: image,
            });
          }
        });
    }
  }
  getExchangePrice() {
    const { productData } = this.props;
    if (!productData && !productData.prices) return;
    const exchangeMarketPrice =
      productData &&
      productData.prices &&
      productData.prices.find(price => price.name === 'Market Price');
    const exchangePrice =
      productData &&
      productData.prices &&
      productData.prices.find(price => price.name === 'Lenskart Price');
    this.setState({ exchangeMarketPrice, exchangePrice });
  }
  fnCreateMyDitto(evt) {
    const { toggleTryOn } = this.props;
    evt.stopPropagation();
    evt.nativeEvent.stopImmediatePropagation();
    // const cta = isTryOnSwitch ? 'Close Try On' : 'Try On';
    if (getSetCookie.getCookie('isDittoID')) {
      toggleTryOn();
    } else {
      localStorage.setItem('dittoCompare', window.location.href);
      window.location.href = '/compare-looks';
    }
  }
  determineCardClass(isDittoVisible, isProductVisible) {
    if (isDittoVisible) {
      return '';
    }
    return isProductVisible ? 'margin-b40' : 'prod-img-container';
  }
  render() {
    const {
      dataLocale,
      productData,
      shortListData,
      shortlistLimitReached,
      redisCommonData,
      setWishList,
      login,
      userInfo,
      productUrl,
      productImage,
      gaqEventsPush,
      showDitto,
      dittoFound,
      onImageError,
      colorOptions,
      setHoverImage,
      isTryOnSwitchCTA,
      isTryOnSwitch,
      mouseInColor,
      mouseOutColor,
      colorObj,
      catImgPattern,
      catImgSmall,
      currencyMark,
      PRODUCT_OFFERID_CONFIG,
      localeInfo,
      redisLoader,
      isExchange,
    } = this.props;
    const { dittoImage, exchangeMarketPrice, exchangePrice } = this.state;
    const { EXCHANGE_CONFIG } = redisCommonData;
    const currencyCode =
      productData.prices && productData.prices.length > 0
        ? productData.prices[0].currency_code
        : dataLocale.CURRENCY_CODE;
    const currencySymbol = <span>{currencyMark[currencyCode]}</span>;
    const {
      REMOVE_FROM_SHORTLIST,
      BOUGHT,
      SIZE,
      SYMBOL_COLON,
      ADD_TO_SHORTLIST,
      CLOSE_TRY_ON,
      TRY_ON,
      SUITED_FOR,
    } = dataLocale;
    let displayProdName = productData.brand_name;
    const tags = productData.tags;
    let exchangeFreeText;
    let exchangeText;
    if (isExchange && EXCHANGE_CONFIG) {
      const exchangeConfig = JSON.parse(EXCHANGE_CONFIG);
      exchangeFreeText = exchangeConfig && exchangeConfig.EXCHANGE_FREE_TEXT;
      exchangeText = exchangeConfig && exchangeConfig.EXCHANGE_TEXT;
    }
    if (productData.classification === 'contact_lens') {
      displayProdName += productData.model_name
        ? ` ${productData.model_name.replace(productData.brand_name, '')}`
        : '';
    }
    let isShortlisted = false;
    if (shortListData) {
      shortListData?.result?.productList?.forEach(slprd => {
        if (slprd.id === productData.id) {
          isShortlisted = true;
        }
      });
    }
    const productRating = productData.avgRating
      ? roundUptoDigits(productData.avgRating, 1)
      : productData.avgRating;
    const specs = productData.specifications;
    const marketPrice = productData.prices[0].price;
    const lenskartPrice = productData.prices[1].price;
    const firstBuyPrice = productData.prices.length === 3 && productData.prices[2].price;
    const finalprice = productData.prices.length === 3 ? firstBuyPrice : lenskartPrice;
    let viewImage;
    if (showDitto && dittoFound && productData.is_ditto && dittoImage) {
      viewImage = (
        <img
          alt={displayProdName}
          className="widget_dittoImg pos-rel"
          src={dittoImage}
          title={displayProdName}
          onError={ev => onImageError(productData, ev)}
          onFocus={ev => setHoverImage('ditto', ev)}
          onMouseEnter={ev => setHoverImage('ditto', ev)}
          onMouseLeave={ev => setHoverImage('ditto', ev)}
        />
      );
      if (localeInfo.countryCode !== 'sg') {
        gaqEventsPush('Ditto', 'DittoNWF_Success', `prod_id:  ${productData.id}`);
      }
    } else {
      if (typeof colorObj === 'undefined') {
        viewImage = (
          <img
            alt={displayProdName}
            className="img-responsive"
            src={productImage}
            style={{ width: '100%' }}
            title={displayProdName}
            onError={ev => onImageLoadError(ev)}
            onFocus={ev => setHoverImage('ditto', ev)}
            onMouseEnter={ev => setHoverImage('enter', ev)}
            onMouseLeave={ev => setHoverImage('leave', ev)}
          />
        );
      } else {
        viewImage = (
          <img
            alt={displayProdName}
            className="img-responsive"
            src={colorObj.image_urls[0].replace(catImgPattern, catImgSmall)}
            style={{ margin: 'auto' }}
            title={displayProdName}
            onError={ev => onImageLoadError(ev)}
          />
        );
      }
      if (typeof _gaq === 'object' && localeInfo.countryCode !== 'sg') {
        gaqEventsPush('Ditto', 'DittoNWF_Failure', `prod_id:  ${productData.id}`);
      }
    }
    let subSelection = 'default';
    if (login) {
      subSelection = userInfo?.result?.hasPlacedOrder ? 'repeat' : 'new';
    }
    const productOfferIdDetails =
      PRODUCT_OFFERID_CONFIG &&
      PRODUCT_OFFERID_CONFIG[productData.offerName] &&
      PRODUCT_OFFERID_CONFIG[productData.offerName][subSelection];
    if (!exchangeMarketPrice && !exchangePrice && isExchange) {
      this.getExchangePrice();
    }
    const isDittoVisible = showDitto && dittoFound && productData.is_ditto && dittoImage;
    const isProductVisible = !redisLoader && productImage;
    return (
      <div className="pos-rel overflow-hidden padding-0">
        <div
          className="wishlist pos-abs right-10 top-15"
          onClick={() => {
            if (!isShortlisted && shortListData?.result?.numberOfProducts >= 50) {
              shortlistLimitReached();
              return;
            }
            if (window.dtm.LenskartRewamp) {
              if (isShortlisted) {
                window.dtm.LenskartRewamp.Listing.click.removeProdcutShortlist(
                  login,
                  productData.id.toString()
                );
              } else {
                window.dtm.LenskartRewamp.Listing.click.shortlist(productData.id.toString());
              }
            }
            addToWishListGA4(productData, login);
            setWishList(productData.id, shortListData);
          }}
        >
          <span
            className={`wishlist-icon cursor-pointer text-center fa fs20 ${
              !isShortlisted ? 'fa-heart-o text-color-black' : 'fa-heart text-color-red'
            }`}
            title={isShortlisted ? REMOVE_FROM_SHORTLIST : ADD_TO_SHORTLIST}
          ></span>
          {productData.wishlistCount > 0 && (
            <span className="wishlist-count text-black fs12 display-block">
              {productData.wishlistCount}
            </span>
          )}
        </div>
        <Link
          className={`no-decoration display-block ${
            showDitto && dittoFound && productData.is_ditto && dittoImage
              ? 'padding-0'
              : 'padding-t20 padding-r20 padding-l20'
          }`}
          target={isExchange ? '' : '_blank'}
          to={{
            pathname:
              productUrl &&
              removeDomainName(
                removeDomainName(productData.product_url, localeInfo?.domain),
                localeInfo?.domainUrl,
                localeInfo?.countryCode
              ),
            state: { productId: productData.id, section: 'prod' },
          }}
        >
          <div
            className={`col-md-12 text-center ${this.determineCardClass(
              isDittoVisible,
              isProductVisible
            )} ${
              showDitto && dittoFound && productData.is_ditto && dittoImage
                ? 'padding-0'
                : 'padding-t15 padding-r15 padding-l15'
            }`}
          >
            <div
              className={`pos-abs ${
                showDitto && dittoFound && productData.is_ditto && dittoImage
                  ? 'img-background'
                  : ''
              }`}
              style={{
                background:
                  showDitto && dittoFound && productData.is_ditto && dittoImage
                    ? `url('${dittoImage}')`
                    : 'none',
              }}
            >
              &nbsp;
            </div>
            {viewImage}
          </div>
          <div>
            <div
              className={`product-info col-md-12 ${
                isDittoVisible ? 'padding-t5' : 'padding-t10'
              } padding-b4 ${
                showDitto && dittoFound && productData.is_ditto && dittoImage
                  ? 'padding-l20 padding-r20'
                  : 'padding-l0 padding-r0'
              } `}
              style={{
                margin:
                  productData.classification === 'contact_lens' ||
                  productData.classification === 'contact_lens_solution' ||
                  productData.classification === undefined ||
                  productData.classification === 'accessories_revenue'
                    ? '0px'
                    : 'none',
              }}
            >
              <div className="col-md-12 no-padding product-info-container">
                <div className="col-md-12 no-padding text-color-black fw700">
                  <div className="widget-text-ellipsis" title={displayProdName}>
                    {displayProdName}
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`border-bottom padding-b4 display-flex justify-content-between width100 align-items-center ${
                showDitto && dittoFound && productData.is_ditto && dittoImage
                  ? 'padding-l20 padding-r20'
                  : 'padding-l0 padding-r0'
              }`}
            >
              <div className="fs11 no-padding margin-r8" style={{ minHeight: '16px' }}>
                {productRating > 0 && (
                  <span className="display-ib padding-t4 padding-b4">
                    <span className="text-color-white bg-color-green display-ib padding-r4 padding-l4 padding-t1 margin-r4 border-radius8">
                      {productRating} <span className="fa fa-star"></span>
                    </span>
                  </span>
                )}
                {productData.purchaseCount > 0 && (
                  <span
                    className={`display-ib text-color-grey margin-r4 ${
                      productRating > 0 ? 'border-left padding-l4' : ''
                    }`}
                  >
                    {productData.purchaseCount} {BOUGHT}
                  </span>
                )}
                {tags && (
                  <span className="tags-content" style={{ whiteSpace: 'nowrap' }}>
                    {tags}
                  </span>
                )}
              </div>
              {isTryOnSwitchCTA && (
                <div
                  className={`${isTryOnSwitch ? 'try-On close-try-on' : 'try-On'}`}
                  onClick={evt => {
                    evt.preventDefault();
                    this.fnCreateMyDitto(evt);
                  }}
                >
                  <span>{isTryOnSwitch ? CLOSE_TRY_ON : TRY_ON}</span>
                  <figure>
                    <img
                      alt={TRY_ON}
                      src="https://static.lenskart.com/media/desktop/img/desktop_pdp_model.png"
                      title={TRY_ON}
                    />
                  </figure>
                </div>
              )}
            </div>
            <div
              className={`col-md-12 padding-0 lh14 ${
                showDitto && dittoFound && productData.is_ditto && dittoImage
                  ? 'padding-l20 padding-r20'
                  : ''
              }`}
              style={{ lineHeight: 2 }}
            >
              <div className="col-md-8 no-padding text-left" style={{ width: 'auto' }}>
                {isExchange && exchangePrice && (
                  <>
                    <span className="text-color-black fw700">
                      {currencySymbol}
                      {Math.round(exchangePrice.price)}
                    </span>
                    &nbsp;
                    {exchangeMarketPrice.price > exchangePrice.price && (
                      <span className="text-color-grey strike-through">
                        {currencySymbol}
                        {exchangeMarketPrice.price}
                      </span>
                    )}
                    <div className="mr-t4">
                      <span className="exchange-price text-color-primary fs11 fw500 fsp9 lh-11 bora-4">
                        {exchangePrice && exchangePrice.price > 0 ? exchangeText : exchangeFreeText}
                      </span>
                    </div>
                  </>
                )}
                {!isExchange && (
                  <>
                    {productOfferIdDetails && productOfferIdDetails.text1 && (
                      <span className="text-color-black fw700">{productOfferIdDetails.text1}</span>
                    )}
                    &nbsp;
                    {
                      <span className="text-color-black fw700">
                        {currencySymbol}
                        {finalprice}
                      </span>
                    }
                    &nbsp;
                    {marketPrice > finalprice && (
                      <span className="text-color-grey strike-through">
                        {currencySymbol}
                        {marketPrice}
                      </span>
                    )}
                  </>
                )}
              </div>
              {specs.length > 0 && specs[0].items.length > 1 && (
                <div className="no-padding text-right text-color-grey fs11">
                  <span className="ic-month display-ib valign-middle"></span>
                  <span className="display-ib valign-middle"> {specs[0].items[1].value}</span>&nbsp;
                  <span className="ic-box display-ib valign-middle"></span>
                  <span className="display-ib valign-middle">
                    {' '}
                    {specs[0].items[0].value.toLowerCase().replace(' per box', 'es')}
                  </span>
                </div>
              )}
            </div>
          </div>
        </Link>
        <div className="footer-options clear-both padding-l20 padding-r20">
          {(productData.suited_for || productData.size) && (
            <p className="fs12 no-decoration text-black margin-b0 inline-block">
              {productData.suited_for ? SUITED_FOR : SIZE}
              {SYMBOL_COLON}&nbsp;
              <span className="fw700">
                {productData.suited_for ? productData.suited_for : productData.size}
              </span>
            </p>
          )}
          {colorOptions && colorOptions.length > 0 && (
            <ColorOptions
              colorOptions={colorOptions}
              dittoFound={dittoFound}
              gaqEventsPush={gaqEventsPush}
              localeInfo={localeInfo}
              mouseInColor={mouseInColor}
              mouseOutColor={mouseOutColor}
              productData={productData}
              productUrl={productUrl}
              redisCommonData={this.props.redisCommonData}
              showDitto={showDitto}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    currencyMark: state.common.currencyMark,
    redisCommonData: state.common.redisCommonData,
    userInfo: state.common.userInfo,
    localeInfo: state.common.localeInfo,
    redisLoader: state.category.redisLoader,
  };
};
export default connect(mapStateToProps, null)(WidgetProductNew);
